<template>
<form @submit.prevent="submit" id="dedicated_form" class="bg-white">
    <div class="container p-3 pt-5 my-4 border in-border-header">
        <kt-form-section is_first>
            <div class="section-header bg-white">
                {{ $t('label.complete_personal_data') }}
            </div>
            <kt-row v-if="current_user.user_type == user_types.REAL">
                <kt-col lg="3" md="3" xs="6">
                    <kt-form-group>
                        <kt-form-label for="birth_crtfct_number">
                            {{ $t('label.birth_crtfct_number') }}
                        </kt-form-label>
                        <kt-form-control
                                id="birth_crtfct_number"
                                name="birth_crtfct_number"
                                v-model="form_data.birth_crtfct_number"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="3" md="3" xs="6">
                    <kt-form-group>
                        <kt-form-label for="birth_crtfct_serial">
                            {{ $t('label.birth_crtfct_serial') }}
                        </kt-form-label>
                        <kt-form-control
                                id="birth_crtfct_serial"
                                name="birth_crtfct_serial"
                                v-model="form_data.birth_crtfct_serial"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="3" md="3" xs="6">
                    <kt-form-group>
                        <kt-form-label for="birth_crtfct_series_letter">
                            {{ $t('label.birth_crtfct_series_letter') }}
                        </kt-form-label>
                        <select
                                id="birth_crtfct_series_letter"
                                name="birth_crtfct_series_letter"
                                v-model="form_data.birth_crtfct_series_letter"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="birthCrtfctSeriesLetter.key"
                                    v-for="birthCrtfctSeriesLetter in birthCrtfctSeriesLetters"
                                    :value="birthCrtfctSeriesLetter.key"
                            >
                                {{ birthCrtfctSeriesLetter.value }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="3" md="3" xs="6">
                    <kt-form-group>
                        <kt-form-label for="birth_crtfct_series_number">
                            {{ $t('label.birth_crtfct_series_number') }}
                        </kt-form-label>
                        <kt-form-control
                                id="birth_crtfct_series_number"
                                name="birth_crtfct_series_number"
                                v-model="form_data.birth_crtfct_series_number"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="gender">
                            {{ $t('label.gender') }}
                        </kt-form-label>
                        <select
                                id="gender"
                                name="gender"
                                v-model="form_data.gender"
                                class="form-control kt-selectpicker"
                        >
                            <option value=1>
                                {{ $t('label.male') }}
                            </option>
                            <option value=0>
                                {{ $t('label.female') }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group style="position:relative; padding: 8px 8px 2px; margin-bottom:0.5rem;">
                        <kt-form-label>
                            {{ $t('label.id_card_back') }}
                        </kt-form-label>
                        <kt-form-label for="id_card_back" class="d-block btn btn-secondary btn-wide label-file">
                            <kt-icon type="fa" name="paperclip"></kt-icon>
                            {{ $t('gateway.btn.click_me') }}
                        </kt-form-label>
                        <input
                                @change="processIdCardFile"
                                type="file"
                                class="custom-file-upload"
                                name="id_card_back"
                                id="id_card_back"
                                accept=".jpg,.jpeg,image/png"
                        />
                        <img
                                id="id_card_preview"
                                :src="form_data.id_card_file"
                                class="preview_img"
                                data-toggle="modal"
                                data-target="#id_card_modal"
                        />
                        <div id="id_card_modal" class="modal fade" role="dialog">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-body">
                                        <img :src="form_data.id_card_file" width="100%" alt="id_card_file">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row v-else-if="current_user.user_type == user_types.LEGAL">
                <kt-col lg="3" md="3" xs="6">
                    <kt-form-group>
                        <kt-form-label for="commercial_name">
                            {{ $t('label.commercial_name') }}
                        </kt-form-label>
                        <kt-form-control
                                id="commercial_name"
                                name="commercial_name"
                                v-model="form_data.commercial_name"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="12" md="12" sm="12">
                    <div class="container p-3 pt-5 my-4 border in-border-header">
                        <kt-form-section>
                            <div class="section-header bg-white">
                                {{ $t('label.complete_first_signatory_data') }}
                            </div>
                            <kt-row>
                                <kt-col lg="3" md="3" sm="6">
                                    <kt-form-group>
                                        <kt-form-label for="signatory_birth_crtfct_number">
                                            {{ $t('label.birth_crtfct_number') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                maxlength="10"
                                                name="signatory_birth_crtfct_number"
                                                id="signatory_birth_crtfct_number"
                                                v-model="form_data.signatory_birth_crtfct_number"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="3" md="3" xs="6">
                                    <kt-form-group>
                                        <kt-form-label for="signatory_birth_crtfct_serial">
                                            {{ $t('label.birth_crtfct_serial') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="signatory_birth_crtfct_serial"
                                                name="signatory_birth_crtfct_serial"
                                                v-model="form_data.signatory_birth_crtfct_serial"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="3" md="3" xs="6">
                                    <kt-form-group>
                                        <kt-form-label for="signatory_birth_crtfct_series_letter">
                                            {{ $t('label.birth_crtfct_series_letter') }}
                                        </kt-form-label>
                                        <select
                                                id="signatory_birth_crtfct_series_letter"
                                                name="signatory_birth_crtfct_series_letter"
                                                v-model="form_data.signatory_birth_crtfct_series_letter"
                                                class="form-control kt-selectpicker"
                                        >
                                            <option
                                                    v-bind:key="birthCrtfctSeriesLetter.key"
                                                    v-for="birthCrtfctSeriesLetter in birthCrtfctSeriesLetters"
                                                    :value="birthCrtfctSeriesLetter.key"
                                            >
                                                {{ birthCrtfctSeriesLetter.value }}
                                            </option>
                                        </select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="3" md="3" xs="6">
                                    <kt-form-group>
                                        <kt-form-label for="signatory_birth_crtfct_series_number">
                                            {{ $t('label.birth_crtfct_series_number') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="signatory_birth_crtfct_series_number"
                                                name="signatory_birth_crtfct_series_number"
                                                v-model="form_data.signatory_birth_crtfct_series_number"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="signatory_gender">
                                            {{ $t('label.gender') }}
                                        </kt-form-label>
                                        <select
                                                id="signatory_gender"
                                                name="signatory_gender"
                                                v-model="form_data.signatory_gender"
                                                class="form-control kt-selectpicker"
                                        >
                                            <option value=1>
                                                {{ $t('label.male') }}
                                            </option>
                                            <option value=0>
                                                {{ $t('label.female') }}
                                            </option>
                                        </select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group style="position:relative; padding: 8px 8px 2px; margin-bottom:0.5rem;">
                                        <kt-form-label>
                                            {{ $t('label.id_card_back') }}
                                        </kt-form-label>
                                        <kt-form-label
                                                for="signatory_id_card_back"
                                                class="d-block btn btn-secondary btn-wide label-file"
                                        >
                                            <kt-icon type="fa" name="paperclip"></kt-icon>
                                            {{ $t('gateway.btn.click_me') }}
                                        </kt-form-label>
                                        <input
                                                @change="processSignatoryIdCardFile"
                                                type="file"
                                                class="custom-file-upload"
                                                name="signatory_id_card_back"
                                                id="signatory_id_card_back"
                                                accept=".jpg,.jpeg,image/png"
                                        />
                                        <img
                                                id="signatory_id_card_preview"
                                                class="preview_img"
                                                data-toggle="modal"
                                                data-target="#signatory_id_card_modal"
                                                :src="form_data.signatory_id_card_file"
                                        />
                                        <div id="signatory_id_card_modal" class="modal fade" role="dialog">
                                            <div class="modal-dialog">
                                                <div class="modal-content">
                                                    <div class="modal-body">
                                                        <img :src="form_data.signatory_id_card_file" width="100%" alt="id_card_file">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                        </kt-form-section>
                    </div>
                </kt-col>
            </kt-row>
        </kt-form-section>
    </div>
    <div class="container p-3 pt-5 my-4 border in-border-header">
        <kt-form-section>
            <div class="section-header bg-white">
                {{ $t('label.shop_data') }}
            </div>
            <kt-row>
                <kt-col lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="farsi_name">
                            {{ $t('label.farsi_name') }}
                        </kt-form-label>
                        <kt-form-control
                                id="farsi_name"
                                name="farsi_name"
                                v-model="form_data.farsi_name"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>

                <kt-col lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="english_name">
                            {{ $t('label.english_name') }}
                        </kt-form-label>
                        <kt-form-control
                                id="english_name"
                                name="english_name"
                                v-model="form_data.english_name"
                                dir="ltr"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="address">
                            {{ $t('label.address') }}
                        </kt-form-label>
                        <select
                                v-if="addresses"
                                id="address"
                                name="address"
                                v-model="form_data.address"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="address.id"
                                    v-for="address in addresses"

                                    :value="address.id"
                            >
                                {{ address.address }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="province">
                            {{ $t('label.province') }}
                        </kt-form-label>
                        <select
                                id="province"
                                name="province"
                                v-model="form_data.province"
                                class="form-control kt-selectpicker"
                                @change="loadCities(false)"
                        >
                            <option
                                    v-bind:key="province.key"
                                    v-for="province in provinces"
                                    :value="province.id"
                            >
                                {{ province.value }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="city">
                            {{ $t('label.city') }}
                        </kt-form-label>
                        <div id="city_select_holder">
                            <select
                                    id="city"
                                    name="city"
                                    class="form-control"
                            >
                            </select>
                        </div>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="phone_number">
                            {{ $t('label.telephone') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="phone_number"
                                name="phone_number"
                                v-model="form_data.phone_number"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="ownership_type">
                            {{ $t('label.ownership_type') }}
                        </kt-form-label>
                        <select
                                id="ownership_type"
                                name="ownership_type"
                                v-model="form_data.ownership_type"
                                class="form-control kt-selectpicker"
                        >
                            <option value=0>
                                {{ $t('label.owner') }}
                            </option>
                            <option value=1>
                                {{ $t('label.tenant') }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12" v-if="form_data.ownership_type == 1">
                    <kt-form-group>
                        <kt-form-label for="rental_contract_number">
                            {{ $t('label.rental_contract_number') }}
                        </kt-form-label>
                        <kt-form-control
                                id="rental_contract_number"
                                name="rental_contract_number"
                                v-model="form_data.rental_contract_number"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12" v-if="form_data.ownership_type == 1">
                    <kt-form-group>
                        <kt-form-label for="rental_expiry_date">
                            {{ $t('label.rental_expiry_date') }}
                        </kt-form-label>
                        <datePicker
                                color="#00c1a4"
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="dddd jDD jMMMM jYYYY"
                                input-class="form-control"
                                id="rental_expiry_date"
                                name="rental_expiry_date"
                                v-model="form_data.rental_expiry_date" type="date" />
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <div class="col-lg-8 col-md-8 col-sm-12">
                    <kt-form-group>
                        <kt-form-label for="category_code">
                            {{ $t('label.subcategory_code') }}
                        </kt-form-label>
                        <select
                                id="category_code"
                                name="category_code"
                                v-model="form_data.category_code"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="category.key"
                                    v-for="category in categories"

                                    :value="category.key"
                            >
                                {{ category.value }}
                            </option>
                        </select>
                    </kt-form-group>
                </div>
                <kt-col lg="4" md="4" sm="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="sheba_number">
                            {{ $t('label.sheba_number') }}
                        </kt-form-label>
                        <select
                                id="sheba_number"
                                name="sheba_number"
                                v-model="form_data.sheba_number"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="sheba_number.id"
                                    v-for="sheba_number in sheba_numbers"

                                    :value="sheba_number.id"
                            >
                                {{ sheba_number.number }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="4" md="4" xs="12">
                    <kt-form-group>
                        <kt-form-label for="certificate_number">
                            {{ $t('label.certificate_number') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="certificate_number"
                                name="certificate_number"
                                v-model="form_data.certificate_number"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="4" md="4" xs="12">
                    <kt-form-group>
                        <kt-form-label for="certificate_issue_date">
                            {{ $t('label.certificate_issue_date') }}
                        </kt-form-label>
                        <datePicker
                                color="#00c1a4"
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="jDD jMMMM jYYYY"
                                input-class="form-control"
                                id="certificate_issue_date"
                                name="certificate_issue_date"
                                v-model="form_data.certificate_issue_date" type="date" />
                    </kt-form-group>
                </kt-col>
                <kt-col lg="4" md="4" xs="12">
                    <kt-form-group>
                        <kt-form-label for="certificate_expiry_date">
                            {{ $t('label.certificate_expiry_date') }}
                        </kt-form-label>
                        <datePicker
                                color="#00c1a4"
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="jDD jMMMM jYYYY"
                                input-class="form-control"
                                id="certificate_expiry_date"
                                name="certificate_expiry_date"
                                v-model="form_data.certificate_expiry_date" type="date" />
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="etrust_certificate_type">
                            {{ $t('label.etrust_certificate_type') }}
                        </kt-form-label>
                        <select
                                id="etrust_certificate_type"
                                name="etrust_certificate_type"
                                v-model="form_data.etrust_certificate_type"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="etrust_certificate_type.key"
                                    v-for="etrust_certificate_type in etrust_certificate_types"

                                    :value="etrust_certificate_type.key"
                            >
                                {{ etrust_certificate_type.value }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="etrust_certificate_expiry_date">
                            {{ $t('label.etrust_certificate_expiry_date') }}
                        </kt-form-label>
                        <datePicker
                                color="#00c1a4"
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="jDD jMMMM jYYYY"
                                input-class="form-control"
                                id="etrust_certificate_expiry_date"
                                name="etrust_certificate_expiry_date"
                                v-model="form_data.etrust_certificate_expiry_date" type="date" />
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>
        <kt-form-section>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="website_address">
                            {{ $t('label.site_address') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="website_address"
                                name="website_address"
                                placeholder="https://mysite.ir/"
                                v-model="form_data.website_address"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="server_ip">
                            {{ $t('label.server_ip') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="server_ip"
                                name="server_ip"
                                v-model="form_data.server_ip"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="business_type">
                            {{ $t('label.business_type') }}
                        </kt-form-label>
                        <select
                                id="business_type"
                                name="business_type"
                                v-model="form_data.business_type"
                                class="form-control kt-selectpicker"
                        >
                            <option value=0>
                                {{ $t('label.physical') }}
                            </option>
                            <option value=1>
                                {{ $t('label.physical_and_virtual') }}
                            </option>
                            <option value=2>
                                {{ $t('label.virtual') }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="programming_language">
                            {{ $t('label.programming_language') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="programming_language"
                                name="programming_language"
                                v-model="form_data.programming_language"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="email">
                            {{ $t('label.email') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="email"
                                name="email"
                                v-model="form_data.email"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>
        <kt-form-section>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="wage">
                            {{ $t('label.wage') }}
                        </kt-form-label>
                        <select
                                id="wage"
                                name="wage"
                                @change="selectChange(false)"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-for="wage in wages"
                                    v-bind:key="wage.id"
                                    :value="wage.id"
                            >
                                {{ wage.value }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>

                <kt-col id="merchant_wage_share_column" lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="merchant_wage_share">
                            {{ $t('label.merchant_wage_share') }}
                        </kt-form-label>
                        <input
                                type="number"
                                max="100"
                                min="0"
                                id="merchant_share_percent"
                                name="merchant_share_percent"
                                v-model="form_data.merchant_share_percent"
                                class="form-control kt-selectpicker"
                                @change="changeWagePercent"
                        >
                    </kt-form-group>
                </kt-col>

                <kt-col id="client_wage_share_column" lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="client_share_percent">
                            {{ $t('label.client_wage_share') }}
                        </kt-form-label>
                        <input
                                type="number"
                                max="100"
                                min="0"
                                id="client_share_percent"
                                name="client_share_percent"
                                disabled
                                v-bind:value="100 - form_data.merchant_share_percent"
                                class="form-control kt-selectpicker"
                        >
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group style="position:relative; padding: 8px 8px 2px; margin-bottom:0.5rem;">
                        <kt-form-label>
                            {{ $t('label.logo') }}
                        </kt-form-label>
                        <kt-form-label for="logo" class="d-block btn btn-secondary btn-wide label-file">
                            <kt-icon type="fa" name="paperclip"></kt-icon>
                            {{ $t('gateway.btn.click_me') }}
                        </kt-form-label>
                        <input
                                @change="processLogoFile"
                                type="file"
                                class="custom-file-upload"
                                name="logo"
                                id="logo"
                                accept="image/png"
                        />
                        <img
                                id="logo_preview"
                                class="preview_img"
                                data-toggle="modal"
                                data-target="#logo_modal"
                                :src="form_data.logo"
                        />
                        <div id="logo_modal" class="modal fade" role="dialog">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-body">
                                        <img :src="form_data.logo" width="100%" alt="id_card_file">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <input type="hidden" name="merchant_wage" id="merchant_wage">
        </kt-form-section>

        <kt-form-action class="mt-4">
            <kt-button
                    class="btn-wide"
                    size="md"
                    variant="success"
                    type="submit"
                    v-bind:wide="true"
                    id="submit_btn"
            >
                {{ $t('panel.profile.update.wizard.form.btn.submit') }}
            </kt-button>
        </kt-form-action>
    </div>
</form>
</template>

<script>
import { subcategories } from '@/constants/subcategories'
import { provinces, fullCities } from '@/constants/provinceCities'
import { birthCrtfctSeriesLetters } from '@/constants/birthCrtfctSeriesLetter'
import $ from 'jquery'
import Inputmask from 'inputmask'
import { mapGetters, mapState } from 'vuex'
import { i18n } from '@/plugins/i18n'
import { userTypes } from '@/constants/userTypes';

export default {
    props: {
        submit: {
            default: () => { return },
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {
            user_types: userTypes,
            provinces: provinces,
            categories: subcategories,
            birthCrtfctSeriesLetters: birthCrtfctSeriesLetters,
            wages: [
                {
                    id: 0,
                    value: this.$t('gateway.wages.from_payer')
                },
                {
                    id: 100,
                    value: this.$t('gateway.wages.from_me')
                },
                {
                    id: 50,
                    value: this.$t('gateway.wages.half')
                }
            ],
            etrust_certificate_types: [
                {
                    key: 1,
                    value: this.$t('etrust_certificate_types.one')
                },
                {
                    key: 2,
                    value: this.$t('etrust_certificate_types.two')
                },
                {
                    key: 0,
                    value: this.$t('etrust_certificate_types.other')
                },
            ],
        }
    },
    mounted() {
        this.$store.dispatch('shebaNumber/fetch')
        .finally(() => {
            Object.keys(this.sheba_numbers).map(key => {
                let number = this.sheba_numbers[key]['number'] == null ? '' : 'IR'+this.sheba_numbers[key]['number'].split('-').join('')
                this.sheba_numbers[key]['number'] = number
            })
        })
        this.$store.dispatch('address/fetch').finally(() => {
            this.afterDispatch()
        })
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })

            document.getElementById('phone_number') && Inputmask('099-99999999').mask(document.getElementById('phone_number'))

            let selected_option = 0
            if (
                this.form_data.merchant_share_percent == 0
                || this.form_data.merchant_share_percent == 100
            ) {
                selected_option = this.form_data.merchant_share_percent
            }

            else if (this.form_data.merchant_share_percent == null)
                selected_option = ''
            else {
                selected_option = 50
            }

            $("#wage").val(selected_option).change();

            this.selectChange(true)

            this.loadCities(true)
        },
        processLogoFile(e) {
            this.form_data.logo = event.target.files[0]
            this.preview_logo_image(e)
        },
        preview_logo_image(event) {
            let reader = new FileReader();
            reader.onload = function()
            {
                let output = document.getElementById('logo_preview');
                output.src = reader.result;
            }
            reader.readAsDataURL(event.target.files[0]);
        },
        processIdCardFile(e) {
            this.form_data.id_card_back = event.target.files[0]
            let output = document.getElementById('id_card_preview');
            output.src = URL.createObjectURL(event.target.files[0]);
            output.onload = function() {
                URL.revokeObjectURL(output.src) // free memory
            }
        },
        processSignatoryIdCardFile(e) {
            this.form_data.signatory_id_card_back = event.target.files[0]
            let output = document.getElementById('signatory_id_card_preview');
            output.src = URL.createObjectURL(event.target.files[0]);
            output.onload = function() {
                URL.revokeObjectURL(output.src) // free memory
            }
        },
        loadCities(load_city) {
            let province = $('#province')
            let city_select_holder = document.getElementById('city_select_holder');
            city_select_holder.innerHTML = ''
            let cities_element = document.createElement("select");
            cities_element.id = 'city';
            cities_element.name = 'city';
            cities_element.className = 'form-control';

            cities_element.onchange = function(){
                this.form_data.city = $('#city').val()
                }.bind(this);

            city_select_holder.appendChild(cities_element)

            let province_val = province.find(":selected").val()
            let m_cities = Object.entries(fullCities)
            let cities
            m_cities.forEach(function (item) {
                if (item[0] == province_val) {
                    cities = item[1]
                }
            })
            cities.forEach(function (item) {
                let option = document.createElement("option");
                option.text = item;
                option.value = item;
                cities_element.appendChild(option)
            })

            if (load_city)
                $('#city').val(this.form_data.city)

            this.form_data.city = cities[0]

            $('#city').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        selectChange(is_first){
            let merchant_wage_share_column = $('#merchant_wage_share_column')
            let client_wage_share_column = $('#client_wage_share_column')
            let merchant_share_percent = $('#merchant_share_percent')
            let client_share_percent = $('#client_share_percent')
            let merchant_wage = $('#merchant_wage')
            let wage = $("#wage")

            if (wage.val() === 0 || wage.val() === '0') {
                merchant_wage_share_column.css("display", "none");
                client_wage_share_column.css("display", "none");
                merchant_share_percent.val(0);
                client_share_percent.val(100);
                merchant_wage.val(0);
            } else if (wage.val() === 100 || wage.val() === '100') {
                merchant_wage_share_column.css("display", "none");
                client_wage_share_column.css("display", "none");
                merchant_share_percent.val(100);
                client_share_percent.val(0);
                merchant_wage.val(100);
            } else {
                if (!is_first) {
                    merchant_wage_share_column.css("display", "block");
                    client_wage_share_column.css("display", "block");
                    merchant_share_percent.val(50);
                    client_share_percent.val(50);
                    merchant_wage.val(50);
                } else {
                    merchant_wage.val(merchant_share_percent.val());
                    merchant_wage_share_column.css("display", "none");
                    client_wage_share_column.css("display", "none");
                }
            }
        },
        changeWagePercent() {
            let merchant_share_percent = $('#merchant_share_percent')
            let merchant_wage = $('#merchant_wage')
            let wage = $("#wage")

            if (
                merchant_share_percent.val() != 0 ||
                merchant_share_percent.val() != 100
            ) {
                merchant_wage.val(merchant_share_percent.val())
            } else {
                merchant_wage.val(wage.val())
            }
        },
    },
    computed: {
        ...mapGetters('address', [
            'addresses'
        ]),
        ...mapGetters('shebaNumber', [
            'sheba_numbers'
        ]),
        ...mapGetters('user', [
            'current_user'
        ]),
    },
}
</script>

<style>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
.in-border-header {
    position: relative;
}
.section-header {
    font-size: 1.1rem;
    background-color: #fff;
    position: absolute;
    padding: 1px 4px;
    top: 0;
    right: 11px;
    transform: translate(0, -50%);
}
.preview_img {
    max-width: 70px;
    max-height: 70px;
    position: absolute;
    top: 10px;
    left: 80px;
}
</style>